
import { Component, Vue, Prop, Watch, Emit } from "vue-property-decorator";
import { translate } from "../../services/translation/translation";
import "./modal-gallery.less";

@Component({
  components: {}
})
export default class ModalGallery extends Vue {
  @Prop() images;
  @Prop() visible;
  @Prop() index;

  private data = {
    visible: true
  };

  mounted() {
    this.data.visible = this.visible;
  }
  updated() {
    this.data.visible = this.visible;
  }

  @Watch("visible", { immediate: true, deep: true })
  onVisible(visible) {
    let self = this;
    this.data.visible = visible;
    if (visible) {
      setTimeout(function() {
        self.initCarusel();
      }, 200);
    } else {
      this.destroyCarusel();
    }
  }
  @Watch("index", { immediate: true, deep: true })
  onIndex(index) {
    setTimeout(function() {
      try {
        ($(".modal-gallery-slick-slider-list") as any).slick(
          "slickGoTo",
          index
        );
      } catch (e) {}
    }, 200);
  }

  trans(key) {
    return translate(key);
  }

  refreshCarusel() {
    this.destroyCarusel();
    this.initCarusel();
  }

  closeModal() {
    this.data.visible = false;
    this.onSettingVisible(false);
    this.destroyCarusel();
  }

  galleryResize() {
    var width = window.innerWidth;
    var height = window.innerHeight;

    if (width >= 960) {
      $(".modal-gallery-image-container").height(height - 160);
    } else if (width >= 600 && width <= 959) {
      $(".modal-gallery-image-container").height(height - 120);
    } else if (width <= 599) {
      $(".modal-gallery-image-container").height(height - 60);
    }
  }

  initCarusel() {
    try {
      ($(".modal-gallery-slick-slider-list") as any).slick({
        dots: false,
        infinite: true,
        centerMode: false,
        rows: 0,
        slidesToShow: 1,
        slidesToScroll: 1,
        lazyLoad: "ondemand",
        prevArrow:
          '<a class="carousel-control-prev gallery-button" href="#gallery" role="button" data-slide="prev"><span class="mdi mdi-chevron-left"></span></a>',
        nextArrow:
          '<a class="carousel-control-next gallery-button" href="#gallery" role="button" data-slide="next"><span class="mdi mdi-chevron-right"></span></a>',
        responsive: [
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: true
            }
          }
        ]
      });
      this.galleryResize();
    } catch (ex) {}
    try {
      window.addEventListener("resize", this.galleryResize);
      window.addEventListener("orientationchange", this.galleryResize);
      $(document).bind('keyup', function(e) {
        if (e.keyCode==37) {
          $('.carousel-control-prev').trigger('click');
        } else if(e.keyCode==39){
          $('.carousel-control-next').trigger('click');
        }
      });
    } catch (e) {}
  }

  destroyCarusel() {
    try {
      ($(".modal-gallery-slick-slider-list") as any).slick("destroy");
    } catch (ex) {}
  }


  @Emit("settingVisible")
  onSettingVisible(value) {}
}
